// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-grid {
  margin-bottom: 10px;
}

.footer-grid {
  min-height: 549px;
  background-color: #ececec;
}

.clsMenuFooter {
  cursor: pointer;
}

.logoFooter {
  margin-left: 20px;
}

.ftext {
  margin-top: 12px;
  line-height: 150%;
  color: #999999;
  font-size: 12px;
}

.clsMainData {
  color: #5d5757;
  line-height: 1.4;
  margin-left: 10px;
}

.clsFooterRow {
  margin-right: -15px;
  margin-left: -15px;
  margin-bottom: -15px;
  background-color: #ececec;
}

.footerBorder {
  border-top: 2px solid var(--ion-color-primary);
  padding-top: 10px;
  padding-left: 10px;
  padding-bottom: 10px;
}

.relative {
  position: relative;
}

.absolute {
  position: absolute;
}

.width_150 {
  width: 150px;
  text-align: center;
  padding: 0;
}

.float_right {
  float: right;
}

.popular {
  padding: 10px 0;
}
.popular > .title {
  font-size: larger;
  font-weight: 500;
}
.popular > .subtitle {
  padding: 10px;
}

.inline-box {
  display: -webkit-box;
}

.pad5 {
  padding: 5px 50px 5px 0;
}

.pad10 {
  padding: 10px;
}

.text-right {
  text-align: right;
}

.footer-logo {
  margin-top: 80px;
}

.footer-bottom-logo {
  margin-top: -45px;
}

.social-image {
  width: 55px;
  float: right;
}

.bottom-links {
  border-top: 2px solid #BDBDBD;
  margin-top: 50px;
}

.link {
  font-size: 1vw;
  text-align: center;
  margin: auto;
  font-weight: bold;
  margin-top: 40px;
  color: #333333;
}`, "",{"version":3,"sources":["webpack://./src/app/components/footer/footer.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;;AAEA;EACE,iBAAA;EACA,yBAAA;AACF;;AACA;EACE,eAAA;AAEF;;AAAA;EAEE,iBAAA;AAEF;;AAAA;EACE,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AAGF;;AADA;EACE,cAAA;EACA,gBAAA;EACA,iBAAA;AAIF;;AAFA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,yBAAA;AAKF;;AAHA;EACE,8CAAA;EAEA,iBAAA;EACA,kBAAA;EACA,oBAAA;AAKF;;AAFA;EACE,kBAAA;AAKF;;AAFA;EACE,kBAAA;AAKF;;AAFA;EACE,YAAA;EACA,kBAAA;EACA,UAAA;AAKF;;AAFA;EACE,YAAA;AAKF;;AAFA;EACE,eAAA;AAKF;AAJE;EACE,iBAAA;EACA,gBAAA;AAMJ;AAJE;EACE,aAAA;AAMJ;;AAFA;EACE,oBAAA;AAKF;;AAFA;EACE,uBAAA;AAKF;;AAFA;EACE,aAAA;AAKF;;AAFA;EACE,iBAAA;AAKF;;AAFA;EACE,gBAAA;AAKF;;AAHA;EACE,iBAAA;AAMF;;AAHA;EACE,WAAA;EACA,YAAA;AAMF;;AAHA;EACE,6BAAA;EACA,gBAAA;AAMF;;AAFA;EACE,cAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AAKF","sourcesContent":["ion-grid {\n  margin-bottom: 10px;\n}\n\n.footer-grid {\n  min-height: 549px;\n  background-color: #ececec;\n}\n.clsMenuFooter {\n  cursor: pointer;\n}\n.logoFooter {\n  //max-width: 100px;\n  margin-left: 20px;\n}\n.ftext {\n  margin-top: 12px;\n  line-height: 150%;\n  color: #999999;\n  font-size: 12px;\n}\n.clsMainData {\n  color: #5d5757;\n  line-height: 1.4;\n  margin-left: 10px;\n}\n.clsFooterRow {\n  margin-right: -15px;\n  margin-left: -15px;\n  margin-bottom: -15px;\n  background-color: #ececec;\n}\n.footerBorder {\n  border-top: 2px solid var(--ion-color-primary);\n  // margin-top: 10px;\n  padding-top: 10px;\n  padding-left: 10px;\n  padding-bottom: 10px;\n}\n\n.relative {\n  position: relative;\n}\n\n.absolute {\n  position: absolute;\n}\n\n.width_150 {\n  width: 150px;\n  text-align: center;\n  padding: 0;\n}\n\n.float_right {\n  float: right;\n}\n\n.popular {\n  padding: 10px 0;\n  > .title {\n    font-size: larger;\n    font-weight: 500;\n  }\n  > .subtitle {\n    padding: 10px;\n  }\n}\n\n.inline-box {\n  display: -webkit-box;\n}\n\n.pad5 {\n  padding: 5px 50px 5px 0;\n}\n\n.pad10 {\n  padding: 10px;\n}\n\n.text-right {\n  text-align: right;\n}\n\n.footer-logo {\n  margin-top: 80px;\n}\n.footer-bottom-logo {\n  margin-top: -45px;\n}\n\n.social-image {\n  width: 55px;\n  float: right;\n}\n\n.bottom-links{\n  border-top: 2px solid #BDBDBD;\n  margin-top: 50px;\n  //height:200px;\n}\n\n.link{\n  font-size: 1vw;\n  text-align: center;\n  margin: auto;\n  font-weight: bold;\n  margin-top: 40px;\n  color:#333333;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
